import React, { useEffect, useMemo, useState } from 'react'
// import { SlEye } from 'react-icons/sl'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Select, Tag, Upload, notification } from 'antd'
import eventImage from '../../../assets/gallery/event.png'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit, BiUser } from 'react-icons/bi'
// import { LuFileUp } from 'react-icons/lu'
import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useDeleteBlog, useGetBlog, useGetBlogCats, useGetBlogs, usePatchBlog, usePostBlogs } from '../../../hooks/blogs/blogs'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js'
import QuillEditor from '../../../components/quillEditor'
import { LuFileUp } from 'react-icons/lu'

function BlogTabs() {
  const [createPayload, setCreatePayload] = useState({
    title:"",
    // imageUrl:"",
    // isActive:"",
    categoryIds:"",
    content:"",
    id:""
  })
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const onCreateOpen = () => setIsCreateOpen(true)
  const [editor, setEditor] = useState("")
  const [editEditor, setEditEditor] = useState(() => EditorState.createEmpty())
  const onViewClose = () => setIsViewOpen(false)
  const [image, setImage] = useState({})
  //   const onViewOpen = () => setIsViewOpen(true)
const [isOpenEdit, setIsOpenEdit] = useState(false)

const onOpenEdit = () => setIsOpenEdit(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()
  // const [note, setNote] = useState("");

  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
  }

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setRows([])
  }

const uploadProps = useMemo(() => ({
  name: 'file',
  method: 'GET',
  multiple: false,
  data: image?.file,
  onChange({file, fileList}) {
    setImage({
      file,
      name: file?.name,
      fileObj: file?.originFileObj,
      url: URL.createObjectURL(file?.originFileObj),
    })
  }
}), [image]);

const {
  data: getData,
  refetch: getFetch,
  isFetching: getLoad,
} = useGetBlogs()

const {
  data: getBlogCat,
  isFetching: getReload,
} = useGetBlogCats()

const successAction = () => {
  getFetch()
  form.resetFields();
  onCloseEdit()
  onCreateClose()
  setImage("")
  setEditor("")
};

const {
  data: getSingleData,
  mutate: getAction,
  isLoading: getSingleLoad,
} = useGetBlog(onOpenEdit)

useEffect(() => {
  setCreatePayload({
    title: getSingleData?.data?.title || "",
    content: getSingleData?.data?.content || "",
    id: getSingleData?.data?.id || "",
    categoryIds: getSingleData?.data?.categories?.map((e)=>(e?.id)) || []
  })
  setEditEditor(getSingleData?.data?.content || "");
  setImage(getSingleData?.data?.thumbnailImageUrl)

  
}, [getSingleData?.data])

const handleEdit = (d) => {
  getAction(d.id)
}

  const {
    mutate: postAction,
    isLoading: postLoad,
  } = usePostBlogs(successAction)
  
  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePatchBlog(successAction)

  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteBlog(successAction)

  const columns = [
    {
      title: "Blog Title",
      dataIndex: "thumbnailImageUrl",
      key:"thumbnailImageUrl",
      render: (e) => <div className='flex items-center gap-3'>
        {/* <Avatar src="">CF</Avatar> */}
        {/* <p className='text-sm font-medium text-dim'>{e}</p> */}
        <Image alt='blog image' width={100} src={e} />
      </div>,
    },
    {
      title: "Blog Title",
      dataIndex: "title",
      key:"title",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    // {
    //   title: "Blog Content",
    //   dataIndex: "content",
    //   key:"3",
    //   render: (e) => 
    //     // <Image src={e} alt='vRV' width={80} />
    //     <p dangerouslySetInnerHTML={{ __html:e}} />
    // },
    // {
    //   title: "Status",
    //   dataIndex: "isActive",
    //   key:"isActive",
    //   render: (e) => 
    //   <Tag className={`{${e} ? ${statusType?.active?.col} : ${statusType?.inactive?.col}} ${e} ? ${statusType?.active?.bd} : ${statusType?.inactive?.bd}} font-bold rounded-2xl px-3 py-0.5`}>{e ? "ACTIVE" : "INACTIVE"}</Tag>
    // },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          // {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
          {key: "edit", label: <button className='flex' id='' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-2 py-auto' /> Edit</button>},
          // {key: "delete", icon: <GoTrash className='!text-base mx-2 py-auto' />, label: <button className='flex' onClick={() => handleConfirm({})}>Delete</button>},
          {key: "delete", label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base mx-2 py-auto'  /> Delete</button>},

        ]}}
      >
        <Button loading={deleteLoad || getSingleLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]

  const onSubmit = (d) => {
    if (!editor) {
      notification.error({
        message: "Failed!",
        description: "Please Blog Content is Required",
      })
    }else if (!image?.fileObj) {
      notification.error({
        message: "Failed!",
        description: "Please Image is Required",
      })
    }else{
      const payload = {
          title: d.title,
          content: editor,
          categoryIds: d.categoryIds,
          thumbnailImage:  image?.fileObj
        }
        postAction(payload)
    }
  }

  const onSubmitEdit = () => {
    // const isActive = !createPayload.isActive ? true : createPayload.isActive;
    // if (!image?.fileObj) {
    //   const payload = {
    //     name: createPayload.name,
    //     id: createPayload.id,
    //     isActive: isActive,
    //     ImageFile: createPayload.ImageFile,
    //   }
    //   putAction(payload)
    //   console.log(payload, 'here')
    // }else{
    //   const payload = {
    //     name: createPayload.name,
    //     id: createPayload.id,
    //     isActive: isActive,
    //     ImageFile: image?.fileObj,
    //   }
    // }
      // console.log(createPayload, 'nere')
      const payload = {
        title: createPayload.title,
        content: editEditor,
        categoryIds: createPayload.categoryIds,
        thumbnailImage:  image?.fileObj,
        id: createPayload.id
      }
      putAction(payload)
  }

  return (
    <PadContainer loading={getLoad || getReload}>
      <TitleContainer
        path={false}
        title="Blog Management"
        className="border border-lit rounded-xl"
        action={<Button onClick={onCreateOpen} className='!bg-light_blue' type='primary' size='large' icon={<FaPlus />}>Add Blog</Button>}
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getData?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 630}
        title={<p className='text-xl font-bold text-light_blue'>New Blog</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Blog Title" name="title" rules={[{required: true, message: 'Please input Title!',},]}>
            <Input size='large' placeholder='Blog Title' />
          </Form.Item> 

          {/* <Form.Item label="Blog Content" name="content" rules={[{required: true, message: 'Please input Content!',},]}>
            <Input.TextArea size='large' placeholder='Blog Content' />
          </Form.Item>  */}

          <Form.Item label="Blog Category" name="categoryIds" rules={[{required: true, message: 'Please input Blog Category!',},]}>
            <Select size='large' placeholder='Select Blog Category' mode="multiple">
              {getBlogCat?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <QuillEditor
              note={editor} 
              setNote={setEditor} 
            />
          </Form.Item>
          <Form.Item>
            <Upload {...uploadProps}>
              <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
            </Upload>
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Blog</p>}
      >
        
        <Form
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
          form={form}
        >
          <Form.Item label="Blog Title" rules={[{required: true, message: 'Please input Blog Title!',},]}>
            <Input 
                size='large' 
                placeholder='Edit Blog Title' 
                prefix={<BiUser />} 
                value={createPayload.title}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, title: value})}
            />
          </Form.Item> 
          <Form.Item label="Permission">
            <Select 
                size='large' 
                placeholder='Select Permission' 
                mode="multiple"
                // defaultValue={getRoleData?.data?.permissions?.map((e)=>(e?.id))}                
                value={createPayload.categoryIds}
                onChange={(value)=> setCreatePayload({...createPayload, categoryIds: value})}
            >
              {getBlogCat?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>    

          <Form.Item>
            <QuillEditor
              note={editEditor} 
              setNote={setEditEditor} 
            />
          </Form.Item> 
          <Form.Item>
            <Upload {...uploadProps}>
              <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
            </Upload>
            {!image?.url &&
              <Image alt='blog image' width={100} src={image} />
            }
          </Form.Item>    
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCloseEdit} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' onClick={onSubmitEdit} loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Blog</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Product image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default BlogTabs